<template>
  <div
    class="sai-list-content"
    ref="saiListContent"
  >
    <ul class="sai-list-content__lists">
      <FaqItem
        v-for="(item, index) in list"
        v-if="item"
        :key="item.talkScriptId"
        :item="item"
        :index="index"
        :action="'search'"
      />
    </ul>
  </div>
</template>
<script>
import Component, { mixins } from 'vue-class-component';
import ListContentWrapperMixin from '@/mixins/ListContentWrapperMixin';

@Component({
  components: {},
  props: {
    filteredItems: Array,
  },
})
export default class Autocomplete extends mixins(ListContentWrapperMixin) {
  get list() {
    return this.filteredItems;
  }
}
</script>
<style lang="scss" scoped>
@import '../style/setting/variable';
</style>



// WEBPACK FOOTER //
// products/390/components/Autocomplete.vue